import Recovery from './RecoveryContainer';

export { Recovery };



// WEBPACK FOOTER //
// ./src/modules/sign/Recovery/index.js